// extracted by mini-css-extract-plugin
module.exports =  {"tips":"tips__okU21"};